import { render, staticRenderFns } from "./DuplicationModal.vue?vue&type=template&id=e8c69eea&scoped=true&"
import script from "./DuplicationModal.vue?vue&type=script&lang=ts&"
export * from "./DuplicationModal.vue?vue&type=script&lang=ts&"
import style0 from "./DuplicationModal.vue?vue&type=style&index=0&id=e8c69eea&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e8c69eea",
  null
  
)

export default component.exports